import { FriendlyCaptchaSDK } from '@friendlycaptcha/sdk';

export const FriendlyCaptcha = new FriendlyCaptchaSDK({
    apiEndpoint: 'eu',
    disableEvalPatching: true,
});

export const FC_FIELD_NAME = 'FcToken';
export const FC_WIDGET_HOOK = 'js-hook-friendly-captcha-element';
export const FC_ATTRIBUTION_TRANSLATION_KEY = 'FriendlyCaptcha.Attribution';

export const FC_WIDGET_COMPLETE = 'frc:widget.complete';
export const FC_WIDGET_ERROR = 'frc:widget.error';
export const FC_WIDGET_EXPIRE = 'frc:widget.expire';
